import {observer} from "mobx-react";
import React from "react";

import {WidgetConfigurationProps} from "controls/designer/features/widgets/widgetConfig";
import {
	CompassWidgetAppearanceType,
	CompassWidgetConfig,
	getCompassWidgetAppearanceOptions,
} from "areas/metrics/widgets/Compass/config";
import {Section} from 'controls/react/layout/section'
import {FormEntryNew, HelpIcon} from "controls/react/form/formEntryNew";
import {AntInput} from "controls/react/ant/antInput";
import {AntSelect} from "controls/react/ant/antSelect";
import {AntInputNumber} from "controls/react/ant/antInputNumber";
import {SketchColorPickerPlain} from "controls/react/colorPicker/sketchColorPicker";
import {i18n} from "core/localization";
import {MetricSelector} from "areas/metrics/components/MetricSelector";
import {AntCheckbox} from "controls/react/ant/antCheckbox";
import {MetricLegendSelect} from "areas/metrics/components/MetricLegendSelect";
import {MetricTooltipSelect} from "areas/metrics/components/MetricTooltipSelect";
import {LabelOptionsEditor} from "areas/metrics/components/LabelOptionsEditor";
import {LabelPosition} from "areas/metrics/components/LabelOptionsEditor/types";

export const Editor = observer((props: WidgetConfigurationProps<CompassWidgetConfig>) => {
	const appearanceType = props.config.appearance.type
	const appearance = props.config.appearance

	return <Section appearance={"none"}
	                contentPadding={false}
	                childrenPadding={true}>
		<Section title={i18n('General')} appearance={"frame-top-only"}>
			<FormEntryNew label={i18n('Title')} model={props.config} modelField={"title"}>
				<AntInput/>
			</FormEntryNew>
		</Section>
		<Section title={i18n('Data')} appearance={"frame-top-only"}>
			<MetricSelector model={props.config.metric}/>
		</Section>
		<Section title={i18n('Display settings')} appearance={"frame-top-only"} childrenPadding={true}>
			<FormEntryNew label={i18n('Appearance')} model={props.config.appearance} modelField={"type"}>
				<AntSelect options={getCompassWidgetAppearanceOptions()}/>
			</FormEntryNew>

			{(appearanceType == CompassWidgetAppearanceType.Generic || appearanceType == CompassWidgetAppearanceType.Radial) &&
				<Section appearance={"none"} childrenPadding={true} direction={"row"}>
					<FormEntryNew label={i18n('Min value')} width={150} model={props.config} modelField={"minValue"}>
						<AntInputNumber/>
					</FormEntryNew>
					<FormEntryNew label={i18n('Max value')} width={150} model={props.config} modelField={"maxValue"}>
						<AntInputNumber/>
					</FormEntryNew>
					<FormEntryNew label={i18n('Labels count')} width={150} model={appearance} modelField={"ticksCount"}>
						<AntInputNumber/>
					</FormEntryNew>
				</Section>
			}

			<Section appearance={"none"} childrenPadding={true} direction={"row"}>
				<FormEntryNew label={i18n('Indicator color')} model={appearance} modelField={"indicatorColor"}>
					<SketchColorPickerPlain/>
				</FormEntryNew>
				{(appearanceType == CompassWidgetAppearanceType.Generic || appearanceType == CompassWidgetAppearanceType.Compass) && <>
					<FormEntryNew  model={appearance} modelField={"invertDial"}>
						<AntCheckbox>{i18n('Invert dial direction')}</AntCheckbox>
					</FormEntryNew>
				</>
				}
			</Section>

			<Section appearance={"none"} childrenPadding={true} direction={"row"}>
				<FormEntryNew label={i18n('Axis color')} model={appearance} modelField={"axisColor"}>
					<SketchColorPickerPlain/>
				</FormEntryNew>
				<FormEntryNew label={i18n('Background color')}
							  model={appearance.paneBackgroundColor}
							  modelField={"startColor"}>
					<SketchColorPickerPlain/>
				</FormEntryNew>
			</Section>

			<FormEntryNew label={i18n("Legend")}
						  model={appearance}
						  headerAdditionalContent={<HelpIcon tooltip={i18n('Metric legend tooltip')}/>}
						  modelField={"legendTemplate"}>
				<MetricLegendSelect/>
			</FormEntryNew>

			<FormEntryNew label={i18n("Tooltip")}
						  model={appearance}
						  modelField={"tooltipTemplate"}
						  headerAdditionalContent={<HelpIcon tooltip={i18n('Metric tooltip tooltip')}/>}>
				<MetricTooltipSelect/>
			</FormEntryNew>

			<LabelOptionsEditor model={appearance.labels.direction}
								name={i18n('Direction label')}
								positions={[LabelPosition.Inside, LabelPosition.Outside]}
			/>
			<LabelOptionsEditor model={appearance.labels.legend}
								name={i18n('Legend')}
								positions={[LabelPosition.Top, LabelPosition.Middle, LabelPosition.Bottom]}
			/>
			<LabelOptionsEditor model={appearance.labels.tick}
								name={i18n('Tick label')}
								positions={[LabelPosition.Inside, LabelPosition.Outside]}
			/>
			<LabelOptionsEditor model={appearance.labels.value}
								name={i18n('Value')}
			/>
		</Section>
	</Section>
})
